import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ChevronRight } from 'lucide-react';
import { trackClick } from '../../utils/analytics';
import { Button } from '../ui/button';
import ntxLogo from '../../assets/ntx-logo.png';

export const HeroSection = ({ scrollToSection }) => (
  <section id="home" className="pt-24 pb-20 bg-zinc-900 relative overflow-hidden">
    <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iIzI2MjYyNiIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9nPjwvc3ZnPg==')] opacity-30"></div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-block mb-4 px-4 py-2 bg-red-600/10 border border-red-600/30 rounded-full">
            <span className="text-red-500 font-semibold text-sm">Locally Owned in Springtown, TX</span>
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            Built for the<br />
            <span className="text-red-600">Texas Landowner</span>
          </h1>
          <p className="text-zinc-400 text-base sm:text-lg font-semibold tracking-wide mb-6">
            Fence &bull; Land &bull; Buildings &bull; Concrete &bull; Gates
          </p>
          <p className="text-zinc-300 text-base mb-8 leading-relaxed max-w-lg">
            Professional property improvements throughout North Texas. From clearing raw acreage to installing fencing, pouring concrete, and constructing buildings — one contractor for your entire project.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/instant-estimate" onClick={() => trackClick('Instant Estimate - Hero', '/')}>
              <Button
                size="lg"
                className="bg-red-600 hover:bg-red-700 text-white font-semibold text-lg px-8 py-6 w-full sm:w-auto"
                data-testid="hero-cta-estimate"
              >
                Get an Instant Estimate <ChevronRight className="ml-2" />
              </Button>
            </Link>
            <Button
              onClick={() => { trackClick('View Our Work - Hero', '/'); scrollToSection('gallery'); }}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-black font-semibold text-lg px-8 py-6"
              data-testid="hero-cta-work"
            >
              View Our Work
            </Button>
          </div>
          <div className="mt-8 flex items-center space-x-6 text-zinc-400">
            <div className="flex items-center space-x-2">
              <Phone size={20} className="text-red-600" />
              <a href="tel:8177235006" className="hover:text-white transition-colors font-medium">817-723-5006</a>
            </div>
          </div>
        </div>
        <div className="relative">
          <div className="absolute inset-0 bg-red-600/20 blur-3xl rounded-full"></div>
          <img
            src={ntxLogo}
            alt="North Texas Welding and Fabrication Logo"
            className="relative z-10 w-full h-auto drop-shadow-2xl"
            data-testid="hero-logo"
          />
        </div>
      </div>
    </div>
  </section>
);
